// 005 FR-001..FR-003, FR-040: who the shopping screens are for. Parent mode: the selected linked
// child (004 selection). On-behalf mode (010): the context's one student.
import type { Api } from "@/api/types";
import { useSelectedStudent } from "@/profile/selection";
import { useParentData } from "@/profile/useParentData";

import { type ShopperStudent, useShopping } from "./shopApi";

export type Shopper = {
  studentId: string | null;
  student: ShopperStudent | null;
  linked: Api["Student"][];
  all: Api["Student"][];
  /** False when the child's school isn't taking orders (FR-028). */
  schoolActive: boolean;
};

export function useShopper(): Shopper {
  const shopping = useShopping();
  const { students } = useParentData();
  const selectedId = useSelectedStudent();
  const all = students.data ?? [];
  const linked = all.filter((s) => s.linked && s.school !== null);
  if (shopping.mode === "onBehalf" && shopping.onBehalf) {
    return {
      studentId: shopping.onBehalf.student.id,
      student: shopping.onBehalf.student,
      linked: [],
      all: [],
      schoolActive: true,
    };
  }
  const student = linked.find((s) => s.id === selectedId) ?? linked[0] ?? null;
  return {
    studentId: student?.id ?? null,
    student,
    linked,
    all,
    schoolActive: student?.school?.status === "ACTIVE",
  };
}

/** "Class 5A" / "LKG B" for a student. */
export function classSectionText(
  classLevel: string | null,
  section: string | null,
): string {
  if (!classLevel) return "";
  const name = classLevel.startsWith("CLASS_")
    ? `Class ${classLevel.slice(6)}`
    : classLevel === "NURSERY"
      ? "Nursery"
      : classLevel;
  return section
    ? name.startsWith("Class ")
      ? `${name}${section}`
      : `${name} ${section}`
    : name;
}
